import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { FaArrowLeft, FaFire, FaTrophy, FaMedal } from "react-icons/fa";
import { API_BASE_URL } from "../../config/apiConfig";

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

const Achievements = () => {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAchievements = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/api/achievements`, { headers: authHeaders() });
                const json = await res.json();
                if (!res.ok) throw new Error(json.message || "Failed to load achievements");
                setData(json.data);
            } catch (err) {
                toast.error(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchAchievements();
    }, []);

    return (
        <div className="min-h-screen bg-gray-50">
            <nav className="bg-[#2148C0] shadow-md px-6 py-4 flex items-center gap-4">
                <button onClick={() => navigate("/dashboard")} className="text-white"><FaArrowLeft size={18} /></button>
                <h1 className="text-xl font-bold text-white">Achievements</h1>
            </nav>

            <div className="max-w-3xl mx-auto p-6 space-y-6">
                {loading && <p className="text-gray-500">Loading...</p>}

                {!loading && data && (
                    <>
                        <div className="grid grid-cols-3 gap-4">
                            <div className="bg-white rounded-xl shadow-sm p-4 text-center">
                                <FaFire className="text-orange-500 mx-auto mb-2" size={22} />
                                <p className="text-2xl font-bold text-gray-800">{data.streak}</p>
                                <p className="text-xs text-gray-500">Day Streak</p>
                            </div>
                            <div className="bg-white rounded-xl shadow-sm p-4 text-center">
                                <FaTrophy className="text-yellow-500 mx-auto mb-2" size={22} />
                                <p className="text-2xl font-bold text-gray-800">{data.completedTests}</p>
                                <p className="text-xs text-gray-500">Exams Done</p>
                            </div>
                            <div className="bg-white rounded-xl shadow-sm p-4 text-center">
                                <FaMedal className="text-purple-500 mx-auto mb-2" size={22} />
                                <p className="text-2xl font-bold text-gray-800">{data.averageScore}%</p>
                                <p className="text-xs text-gray-500">Avg Score</p>
                            </div>
                        </div>

                        <div>
                            <h3 className="font-semibold text-gray-800 mb-3">Badges</h3>
                            {data.badges.length === 0 && (
                                <p className="text-sm text-gray-500">Keep practicing — your first badge is close!</p>
                            )}
                            <div className="grid grid-cols-2 gap-3">
                                {data.badges.map((b, i) => (
                                    <div key={i} className="bg-white rounded-xl shadow-sm p-4 flex items-center gap-3">
                                        <div className="bg-yellow-50 text-yellow-600 p-2 rounded-lg"><FaMedal /></div>
                                        <div>
                                            <p className="font-semibold text-gray-800 text-sm">{b.name}</p>
                                            <p className="text-xs text-gray-500">{b.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button onClick={() => navigate("/leaderboard")} className="text-blue600 font-semibold text-sm">
                            See where you rank on the Leaderboard →
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default Achievements;
